import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { faCheck, faExclamationTriangle, faPen, faSpinner } from '@fortawesome/pro-light-svg-icons';
import { TranslocoService } from '@ngneat/transloco';
import FileSaver from 'file-saver';
import { ConfirmationService } from 'primeng/api';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { CandidateModel } from 'projects/runner/src/app/models/candidate.model';
import { ReportModel } from 'projects/runner/src/app/models/report.model';
import { ApiService } from 'projects/runner/src/app/services/api.service';
import { UiService } from 'projects/runner/src/app/services/ui.service';

@Component({
  selector: 'app-ai-report',
  templateUrl: './ai-report.component.html',
  styleUrl: './ai-report.component.scss'
})
export class AiReportComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef;

  @Input() ac: AcModel | null = null;
  @Input() candidate: CandidateModel | null = null;
  @Input() report: ReportModel | null = null;

  @Output() reportChange = new EventEmitter<ReportModel>();

  public visible = false;
  public busy = false;

  public faSpinner = faSpinner;
  public faError = faExclamationTriangle;
  public faDraft = faPen;
  public faProgress = faPen;
  public faFinished = faCheck;

  constructor(
    private api: ApiService,
    private confirmation: ConfirmationService,
    private transloco: TranslocoService,
    private ui: UiService
  ) { }

  ngOnInit(): void {
  }

  public onClose(): void {
    this.visible = false;
  }

  // public regenerateReport(): void {
  //   this.busy = true;
  //   this.api
  //     .regenerateResultReport(this.candidate?.id)
  //     .subscribe({
  //       next: (result: any) => {
  //         this.reportChange.emit(new ReportModel().deserialize(result.data));
  //       },
  //       error: (error: any) => {
  //       }
  //     }).add(() => {
  //       this.busy = false;
  //     });
  // }

  public finishReport(): void {
    this.confirmation.confirm({
      message: this.transloco.translate('dashboard.resultreport.really_finish'),
      header: this.transloco.translate('common.labels.info'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.transloco.translate('common.labels.ok'),
      rejectLabel: this.transloco.translate('common.labels.cancel'),
      accept: () => {
        this.busy = true;
        this.api
          .finishResultReport(this.candidate?.id)
          .subscribe({
            next: (result: any) => {
              this.reportChange.emit(new ReportModel().deserialize(result.data));
              this.onClose();
            },
            error: (error: any) => {
            }
          }).add(() => {
            this.busy = false;
          });
      }
    });
  }

  public uploadReport(): void {
    this.fileInput.nativeElement.click();
  }

  public onUploadFile(files: FileList): void {
    if (files.length > 0) {
      this.api.uploadResultReport(this.candidate.id, files[0]).subscribe({
        next: (result: any) => {
          this.reportChange.emit(new ReportModel().deserialize(result.data));
          this.fileInput.nativeElement.value = '';
          this.ui.toastSuccess(this.transloco.translate('common.labels.upload_success'));
        },
        error: (error: any) => {
          this.ui.toastError(this.transloco.translate('common.labels.upload_error'));
        }
      });
    }
  }

  public downloadReport(): void {
    this.api
      .downloadFile(
        'candidate.file',
        this.candidate?.id,
        this.report?.id
      )
      .subscribe({
        next: (response: any) => {
          const blob = new Blob([response]);
          FileSaver.saveAs(blob, this.report?.public_name);
        }
      });
  }

}
